export const consumer = {
  smartphones:
    '/mobility/phones?sessionFlow=consumer&linkname=Phones&linktype=outofstock_error_message',
  smartwatches:
    '/mobility/devices/category/smartwatches?linkname=Smartwatches&linktype=outofstock_error_message',
  tablets: '/mobility/devices/category/tablets?linkname=Tablets&linktype=outofstock_error_message',
  accessories: '/mobility/accessories'
}

export const business = {
  smartphones:
    '/business/small/mobility/smartphones?INTCMP=smb_atl_wls-mdev_nav_mobility-deals_shop-all-smartphones_220412_hp_hpmd_na_tcom_offer&linktype=outofstock_error_message',
  smartwatches:
    '/business/small/mobility/devices/category/smartwatches?linktype=outofstock_error_message&linkname=Smartwatches',
  tablets:
    '/business/small/mobility/devices/category/tablets?linktype=outofstock_error_message&linkname=Tablets',
  accessories:
    '/business/small/mobility/accessories?&linktype=outofstock_error_message&linkname=Accessoriess'
}

export const outOfStockError = '&linktype=outofstock_error_message'
